module.exports = __webpack_public_path__ + "static/media/android-3.2d302c67.jpg";